import { prvIf } from 'domain/preview'
import { callPlanet } from './'

// export type FetchResourceApiResponse = {|
//   +resourceKey: string,
//   +resources: Resource
// |}

// export type FetchResourceApiRequest = {
//   +response: FetchResourceApiResponse,
// }

// type FetchResource = (
//   saleKey: string,
//   resourceKey: string,
//   countryCode: string,
//   cultureCode: string,
//   marketId: number,
//   version: number,
//   isPreview: boolean,
// ) => Observable<FetchResourceApiRequest>

export const fetchResource = (
  saleKey,
  resourceKey,
  countryCode,
  cultureCode,
  marketId,
  saleVersion,
  isPreview = false,
  isResourceV2 = false
) => {
  const device = 'web' // Should be dynamic but API is not ready
  const apiVersion = isResourceV2 ? '/v2' : ''

  return callPlanet(
    `static/content${apiVersion}/flatten/${countryCode}/${cultureCode}/${device}/${marketId}/${saleKey}/${resourceKey}/${saleVersion}${prvIf(isPreview)}`
  )
}
